import { api } from '@/api/Api'
import { useRouter } from 'vue-router'
import { useToast } from '@/composables/useToast'

export function useRidActions() {
  const { toast } = useToast()
  const router = useRouter()

  const doCreateUnplanned = async (projectId) => {
    try {
      await api.rid().createUnplanned(projectId)
      toast.success('Создание внепланового РИД успешно запланировано')
    } catch {
      toast.error('Не удалось инициировать создание внепланового РИД')
    }
  }

  const doRealize = (projectId, pointHumanId) => {
    router.push(`/tasks/${pointHumanId}`)
  }

  const doActualize = async (projectId, ridType, ridPlanCode, ridCode) => {
    try {
      await api.rid().actualize(projectId, ridType, ridPlanCode, ridCode)
      toast.success('Актуализация РИД успешно запланирована')
    } catch ({ response }) {
      if (response.status === 409) {
        toast.error('РИД находится на редактировании, подать обновление невозможно')
      } else {
        toast.error('Не удалось инициировать обновление РИД')
      }
    }
  }

  return {
    doCreateUnplanned,
    doRealize,
    doActualize,
  }
}
